import { useEffect, useState } from "react";
import { MapPin, Phone, Award, Store } from "lucide-react";
import { api } from "../lib/api";

const KIOSK_IMG = "https://images.unsplash.com/photo-1721937718756-3bfec49f42a2?crop=entropy&cs=srgb&fm=jpg&q=85";

export default function Kedai() {
  const [kiosks, setKiosks] = useState([]);
  useEffect(() => { api.get("/kiosks").then((r) => setKiosks(r.data.kiosks)); }, []);

  return (
    <div className="max-w-6xl mx-auto px-6 py-10">
      <div className="text-center mb-10">
        <span className="text-xs font-semibold uppercase tracking-widest text-secondary">Jaringan Mitra</span>
        <h1 className="font-display text-3xl lg:text-4xl font-bold text-stone-900 mt-2">Kedai Lokal di Daerahmu</h1>
        <p className="text-stone-500 mt-2 max-w-2xl mx-auto">Kedai kecil di tiap kecamatan membantu warga awam belajar cara beli barang dari China, memesankan, dan menjadi tempat pengambilan paket.</p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="kedai-grid">
        {kiosks.map((k) => (
          <div key={k.id} className="bg-white rounded-2xl border border-stone-200 overflow-hidden hover:shadow-md transition">
            <img src={KIOSK_IMG} alt={k.name} className="h-32 w-full object-cover" />
            <div className="p-5">
              <div className="flex items-center gap-2 mb-2"><Store size={18} className="text-secondary" /><h3 className="font-display font-semibold text-stone-900">{k.name}</h3></div>
              <p className="text-sm text-stone-500 flex items-start gap-1.5"><MapPin size={15} className="mt-0.5 shrink-0" />{k.address}, {k.subdistrict}, {k.city} ({k.region})</p>
              {k.phone && <p className="text-sm text-stone-500 flex items-center gap-1.5 mt-1"><Phone size={14} />{k.phone}</p>}
              <div className="mt-3 flex items-center gap-1.5 text-xs font-semibold text-amber-600 bg-amber-50 w-fit px-2.5 py-1 rounded-full"><Award size={13} />{k.points} poin mitra</div>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-12 bg-emerald-900 rounded-3xl p-8 text-center text-white">
        <h2 className="font-display text-2xl font-bold">Punya kedai/warung? Jadi Mitra Kami</h2>
        <p className="text-emerald-100/80 mt-2 max-w-xl mx-auto text-sm">Bantu warga di daerahmu belanja grosir dari China, dapatkan komisi & poin bonus setiap pesanan yang kamu dampingi.</p>
      </div>
    </div>
  );
}
